import React from 'react';

import { ProofPanel } from './ProofPanel';

interface AuthLayoutProps {
  children: React.ReactNode;
}

/**
 * Split-layout auth shell.
 * - >= 880px: two-column grid. Left = cream form pane (centered, max-w-[392px]
 *   inner column) renders {children}; right = dark-navy proof pane.
 * - < 880px: form pane only (proof pane hidden).
 *
 * Each page supplies its own logo + content as {children}.
 */
export const AuthLayout = ({ children }: AuthLayoutProps): JSX.Element => {
  return (
    <div className="min-h-dvh w-full font-onboarding-2 min-[880px]:grid min-[880px]:grid-cols-2">
      {/* Left — cream form pane */}
      <div className="bg-cream flex min-h-dvh flex-col items-center justify-center px-6 py-7 min-[880px]:min-h-dvh min-[880px]:p-12">
        <div className="flex w-full max-w-[392px] flex-col gap-[18px]">{children}</div>
      </div>

      {/* Right — proof pane (desktop only) */}
      <div className="proof-pane hidden items-center justify-center p-12 min-[880px]:flex">
        <ProofPanel />
      </div>
    </div>
  );
};
